import styled from "@emotion/styled";

interface RainbowKitWalletButtonContainerProps {
  ready: boolean;
}

export const RainbowKitWalletButtonContainer = styled.div<RainbowKitWalletButtonContainerProps>`
  opacity: ${props => (!props.ready ? 0 : "inherit")};
  pointer-events: ${props => (!props.ready ? "none" : "inherit")};
  user-select: ${props => (!props.ready ? "none" : "inherit")};
`;
